import React from 'react';
import './SpecialitySection.css';

function SpecialitySection() {
  const specialties = [
    {
      title: 'Soft Touch Cleaning',
      description: 'Gentle yet effective cleaning methods'
    },
    {
      title: 'Trained & Professional',
      description: 'Our team consists of certified professionals'
    },
    {
      title: 'Deep Cleaning Practice',
      description: 'Thorough cleaning for every corner'
    }
  ];

  return (
    <section className="speciality-section animate-on-scroll">
      <div className="container">
        <h2 className="section-title">Our Speciality</h2>
        <div className="speciality-grid">
          {specialties.map((specialty, index) => (
            <div key={index} className="speciality-item">
              <div className="speciality-icon">
                {index + 1}
              </div>
              <h3>{specialty.title}</h3>
              <p>{specialty.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default SpecialitySection;
